'use strict';

/**
 * Author:fanglijuan
 *
 * Time:2019-04-24
 */
angular.module('quickSignManuscriptAssociationModule', []).controller('quickSignManuscriptAssociationCtrl', ['$scope', '$sce', '$q', '$modal', '$timeout', '$state', '$location', '$window', '$filter', 'trsHttpService', '$stateParams', 'editcenterRightsService', 'modalDialog', 'editingCenterService', 'localStorageService', 'initSingleSelecet', 'appQuickSignService',
    function($scope, $sce, $q, $modal, $timeout, $state, $location, $window, $filter, trsHttpService, $stateParams, editcenterRightsService, modalDialog, editingCenterService, localStorageService, initSingleSelecet, appQuickSignService) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化页面参数
         * @return {[type]} [description]null
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 10,
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            $scope.data = {
                items: [],
                selectedArray: [],
            };
            $scope.status = {
                keywords: '',
                copyCurrPage: 1,
            };
            $scope.params = {
                serviceid: 'mlf_appquickpublish',
                methodname: 'queryRels',
                CURRPAGE: $scope.page.CURRPAGE,
                PAGESIZE: $scope.page.PAGESIZE,
                // CHANNELID: $stateParams.channelid,
                SITEID: $stateParams.siteid,
                reltype: 1, // 关联类型:1为稿件，2为推送
                ismine: 0, // 默认全部，0为查询所有 1为查询用户
                status: 1,
            };
        }

        /**
         * [initData description]初始化页面数据
         * @return {[type]} [description]null
         */
        function initData() {
            $scope.data.conditionsSearch = initSingleSelecet.quickSginStatus();
            initParams();
            requestData();
        }
        // 还原:初始化部分参数
        function initParams() {
            $scope.params.CURRPAGE = $scope.page.CURRPAGE = $scope.status.copyCurrPage = 1;
            $scope.params.keyword = $scope.status.keywords = '';
            $scope.data.selectedArray = $scope.data.items = [];
        }

        /**
         * [fullTextSearch description;全文检索]
         * @param  {[type]} ev [description:按下空格也能提交]
         */
        $scope.fullTextSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.params.keyword = $scope.status.keywords;
                $scope.page.CURRPAGE = 1;
                requestData();
            }
        };
        
        /**
         * [requestData description]获取列表数据
         * @return {[type]} [description]
         */
        function requestData() {
            $scope.data.selectedArray = $scope.data.items = [];
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'post').then(function(data) {
                $scope.data.items = data.DATA;
                $scope.page = data.PAGER;
            });
        }

        /**
         * [selectAll description]全选列表
         * @return {[type]} [description] null
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
        };

        /**
         * [chooseItem description] 勾选
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.chooseItem = function(item) {
            if ($scope.data.selectedArray.indexOf(item) < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            }
        };

        /**
         * [pageChanged description]下一页
         * @return {[type]} [description] null
         */
        $scope.pageChanged = function() {
            $scope.params.CURRPAGE = $scope.page.CURRPAGE;
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };
        // 选择单页显示个数
        $scope.selectPageNum = function() {
            $scope.params.PAGESIZE = $scope.page.PAGESIZE;
            $scope.params.CURRPAGE = $scope.page.CURRPAGE;
            $scope.status.copyCurrPage = 1;
            requestData();
        };

        /**
         * [jumpToPage description] 跳转到指定页面
         * @return {[type]} [description]
         */
        $scope.jumpToPage = function() {
            if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
            }
            if ($scope.status.copyCurrPage < 1) {
                $scope.status.copyCurrPage = 1;
            }
            $scope.params.CURRPAGE = $scope.status.copyCurrPage;
            requestData();
        };

        /**
         * [adopt description] 审核通过
         * @return {[type]} [description]
         */
        $scope.adopt = function() {
            modalDialog.confirmModal('选中关联' + $scope.data.selectedArray.length + '项', '确定审核通过？', function() {
                var objectids = [];
                for (var i = $scope.data.selectedArray.length - 1; i >= 0; i--) {
                    objectids.push($scope.data.selectedArray[i].QUICKPUBCHANNELCATEGORYRELID);
                }
                var params = {
                    serviceid: 'mlf_appquickpublish',
                    methodname: 'checkRels',
                    SITEID: $stateParams.siteid,
                    ObjectIds: objectids.join(),
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    if (data.ISSUCCESS) {
                        modalDialog.alertType('审核成功', '', 'success', false, function() {
                            requestData();
                        });
                    }
                });
            }, function() {});
        };

        /**
         * [goBack description]退回
         * @return {[type]} [description]
         */
        $scope.goBack = function() {
            var objectids = [];
            for (var i = $scope.data.selectedArray.length - 1; i >= 0; i--) {
                objectids.push($scope.data.selectedArray[i].QUICKPUBCHANNELCATEGORYRELID);
            }
            modalDialog.inputModel('选中关联' + $scope.data.selectedArray.length + '项', '请输入退回原因', function(content) {
                doBack(content, objectids);
            });
        };

        /**
         * [doBack description]退回函数
         * @return {[type]} [description]
         */
        function doBack(content, objectids) {
            var params = {
                serviceid: 'mlf_appquickpublish',
                methodname: 'refuseRels',
                SITEID: $stateParams.siteid,
                ObjectIds: objectids.join(),
                opinion: content,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function() {
                modalDialog.alertType('退回稿件成功', '', 'success', false, function() {
                    requestData();
                });
            }, function() {
                requestData();
            });
        }
    }
]);
